import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { FaLightbulb, FaHeart, FaCheckSquare, FaApple, FaAndroid } from 'react-icons/fa';
import './download_app.css';
import appMockUp from '../../../src/images/mobile_app_mockup.png';
import iphoneMockUp from '../../images/mobile_app_mockup_1.png';
const DownloadAppUI = () => {
  const [showMsg, setShowMsg] = useState(false);

  const handleDownloadClick = (e) => {
    e.preventDefault();
    setShowMsg(true);
  };
  return (
    <div className="download-app-section">
      <Container className="py-2 px-4 download-app-container">
        <Row className="align-items-center h-auto">
          <Col md={6} className="text-center text-md-start mb-4 mb-md-0">
            <h2 className="mb-3 download-app-title">Download The Wedstra Mobile App Today!</h2>

            <div className="mb-4 feature-list">
              <p className="feature-text">
                <FaLightbulb className="me-2" /> Save Wedding Ideas
              </p>
              <p className="feature-text">
                <FaHeart className="me-2" /> Shortlist Vendors
              </p>
              <p className="feature-text">
                <FaCheckSquare className="me-2" /> Get Free Wedding Checklist
              </p>
            </div>

            <p className="mt-4 sms-info-text">You will receive an SMS with a link to download the App</p>

            <Form className="mt-3 d-flex flex-column align-items-center align-items-md-start">
              <Form.Group className="mb-3 d-flex align-items-center phone-input-group">
                <Form.Control
                  type="tel"
                  placeholder="Mobile Number"
                  className="p-2 phone-input"
                  maxLength={10}
                />
              </Form.Group>

              <Button
                variant="primary"
                className="mt-3 py-2 px-4 download-btn"
                onClick={handleDownloadClick}
              >
                Download the App
              </Button>
              {showMsg && (
                <Alert
                  variant="info"
                  className="mt-3"
                  onClose={() => setShowMsg(false)}
                  dismissible
                >
                  This feature is currently under development.
                </Alert>
              )}
            </Form>

            <div className="mt-4 justify-content-center justify-content-md-start app-store-icons">
              <FaApple size={30} className="app-store-icon" />
              <FaAndroid size={30} className="app-store-icon" />
            </div>
          </Col>

          <Col md={6} className="d-flex justify-content-center align-items-center mt-0 p-3">
            <img src={appMockUp} alt="Mobile App Mockup" className="app-mockup-image" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DownloadAppUI;